/**
 * Created by synerzip on 08/02/16.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import * as adminActionCreator from '../../actions/admin';
import * as appActionCreator from '../../actions/app';
import * as commonActionCreator from '../../actions/common';
import * as notificationsActionCreator from '../../actions/notifications';
import { connect } from 'react-redux';
import { Button, Nav, NavItem, NavDropdown, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';
import _ from 'lodash';
import TODOList from './TODOList';
import GAPSPlanList from './GAPSPlanList'
import CloseChartPopup from './CloseChartPopup';
import ReconsentRequiredModal from './ReconsentRequiredModal';
import APCMReconsentRequiredModal from './APCMReconsentRequiredModal'
import APCMLevelChangeConsentRequiredModal from "./APCMLevelChangeConsentRequiredModal"
import CaseHistoryView from './CaseHistoryView';
import CarePlanAndGoal from './CarePlanAndGoal';
import PatientEducation from "./PatientEducation";
import AssessmentView from './AssessmentView';
import MIPSAssessmentView from './MIPSAssessmentView';
import PathwayStrokeCareAssessmentView from './PathwayStrokeCareAssessmentView'
import GeneralNotes from './GeneralNotes';
import Labs from './Labs';
import WorkLoggedCell from './WorkLoggedCell';
import CCDA from './CCDA';
import PHS from './PHS';
import {
    PATIENT_STATUS_NEW,
    PATIENT_STATUS_UNVERIFIED,
    PATIENT_STATUS_AE_APPROVED,
    PATIENT_STATUS_OPTED_OUT,
    PATIENT_STATUS_RPM_UNVERIFIED,
    PATIENT_STATUS_SUPPORT,
    RPM_ADDON_STATUS_ELIGIBLE,
    RPM_ADDON_STATUS_NEW,
    RPM_ADDON_STATUS_ACTIVE,
    getRpmDeviceTypeLabel,
} from '../../constants/other';
import ChartspanWebComponent from './ChartspanWebComponent';
import RPMImpactTab from './RPMImpactTab';
import RpmAddonEnrollmentModal from './RpmAddonEnrollmentModal';
import RpmDualEnrollmentModal from './RpmDualEnrollmentModal';
import RpmAddonDeclineModal from './RpmAddonDeclineModal';
import RpmEnrollmentCompleteModal from './RpmEnrollmentCompleteModal';
import InactivityCloseChartPopup from './InactivityCloseChartPopup';
import NotificationInboxItemDetail from '../notification/NotificationInboxItemDetail'
import ChartCaseMessagesList from '../caseMessages/ChartCaseMessagesList'
import {
    getConsentTypeLabel,
    isAdmin,
    isAutoDial,
    isMA,
    isTriage,
    numberToPhone,
    isPCA,
    isRpmEnrollerClinicalCenter,
    hasRpmEnrollInChartUx,
    usesPrimaryChartAccess,
    getPatientActiveWorkItemId,
} from '../../utils'
import { openRpmImpactPopupSync } from '../../utils/rpmImpactLaunch';
import { getRpmEligibleChipStyle } from '../../utils/programChipHelpers';
import moment from 'moment';
import RequestRecordContainer from './RequestRecordContainer';
import Utilities from './Utilities';
import NewRecordsDropdown from './NewRecordsDropdown';
import OptOutModal from './OptOutModal';
import PatientSatisfactionModal from './PatientSatisfactionModal';
import ConfirmationModal from './ConfirmationModal';
import EmailConfirmationModal from './EmailConfirmationModal';
import ScheduleNextCallPopup from './ScheduleNextCallPopup'
import NotesModal from './NotesModal';
import PatientStatusUpdateModal from './PatientStatusUpdateModal';
import PageHeader from '../../components/PageHeader';
import NotificationOfChartClosureRequestModal from './NotificationOfChartClosureRequestModal';
import AssociatedChartsModal from './AssociatedChartsModal';
import config from "../../config";
import EditPatientInformationPopup from './EditPatientInformationPopup';
import RpmThresholdChartAlertsPanel from './RpmThresholdChartAlertsPanel';
import CompleteTODOPopup from './CompleteTODOPopup';

class LevelTwoDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.idleSecondsCounter = 0;
        this.idleSecondsInterval = null;
        this.idleTimeOut = 300;
        this.resetTimer = this.resetTimer.bind(this);
        this.checkInactivityTimeOut = this.checkInactivityTimeOut.bind(this);
        this.handleSelectSessionNotes = this.handleSelectSessionNotes.bind(this);
        this.closeChartTitle = 'Session Notes';
        this.state = {
            iframeURL: null,
            selectedOption: 'todoList',
            show: false,
            autoCloseChartShow: false,
            showEditPatientInfo: false,
            hasCheckedMedSummary: false,
            hasCheckedHealthSummary: false,
            hasCheckedQualitySummary: false,
            hasCheckedCCDA: false,
            showNotes: false,
            showMergePatient: false,
            showOptOut: false,
            showBillableLimit: false,
            showConfirmation: false,
            showDualEnrollmentModal: false,
            showScheduleNextCall: false,
            showEmailConfirmation: false,
            showSecondaryTimer: false,
            showNotificationOfChartClosureRequestModal: false,
            showPatientSatisfactionModal: false,
            showPatientStatusUpdate: false,
            satisfactionRating: null,
            satisfactionNotes: '',
            satisfactionDateDiff: null,
            showPatientServicesModal: false,
            notes: undefined,
            showAssociatedCharts: false,
            scheduleNextCallDate: null,
            scheduleNextCallSlot:null,
            completingRpmAlertTodoId: null,
            showRpmAlertCompleteTodo: false,
            rpmAlertCompleteTodoData: null,
            sdkReady: false,
            callStatus: '',
            callStatusByNumber: {}, // Track call status by number type (phone/mobile)
            copiedNumberType: null,
            isIframeCollapsed: false,
            patientDetailReady: false,
            showRpmEnrollmentModal: false,
            showRpmDeclineModal: false,
            showRpmEnrollmentCompleteModal: false,
            rpmEnrollmentUiEnrolled: false,
            rpmEnrollmentSummary: null,
        };
        this.handleScroll = _.debounce(this.handleScroll, 100);
        this.setSdkReady = this.setSdkReady.bind(this);
        this.setCallStatus = this.setCallStatus.bind(this);
        this.loadPatientDetailForTimer = this.loadPatientDetailForTimer.bind(this);
    }

    loadPatientDetailForTimer(patientId) {
        const { activeUser, user } = this.props;
        const shouldShowWorkTimer = usesPrimaryChartAccess(activeUser, user.roles);
        if (!shouldShowWorkTimer) {
            this.setState({ patientDetailReady: false });
            return;
        }
        this.setState({ patientDetailReady: false });
        this.props.adminActions.getPatientDetail(patientId)
            .then(() => {
                if (this.props.patient && this.props.patient.id === patientId) {
                    this.setState({ patientDetailReady: true });
                }
            });
    }

    setSdkReady(status) {
        this.setState({sdkReady: status});
    }
    setCallStatus(status, numberType = null){
       if (numberType) {
            this.setState(prevState => ({
                callStatusByNumber: {
                    ...prevState.callStatusByNumber,
                    [numberType]: status
                }
            }));
            // Auto-clear status after 5 seconds for success, 10 seconds for errors
            const timeout = 1000;
            setTimeout(() => {
                this.setState(prevState => ({
                    callStatusByNumber: {
                        ...prevState.callStatusByNumber,
                        [numberType]: null
                    }
                }));
            }, timeout);
        }
    }

    closeChart() {
        this.closeChartTitle = 'Close Patient Chart';
        this.setState({ show: true });
        this.props.patient && this.props.adminActions.getWorkSummary(this.props.patient.id);
        this.showSecondaryTimer();
    }
    popoverHoverFocus(description) {
        if(!description){
            return <div/>;
        }
        return (
            <Popover id="popover-trigger-hover-focus">
                <span>{description}</span>
            </Popover>
        )
    }

    openReconsentModal() {
        this.setState({ showReconsentModal: true });
        this.showSecondaryTimer();
    }

    openAPCMReconsentModal() {
        this.setState({ showAPCMReconsentModal: true });
        this.showSecondaryTimer();
    }
    onReconsentAPCMPopupHide() {
        this.setState({ showAPCMReconsentModal: false });
        this.showSecondaryTimer();
    }

     openAPCMLevelChangeConsentModal() {
        this.setState({ showAPCMLevelChangeConsentModal: true });
        this.showSecondaryTimer();
    }
    onAPCMLevelChangeConsentAPCMPopupHide() {
        this.setState({ showAPCMLevelChangeConsentModal: false });
        this.showSecondaryTimer();
    }

    openDualEnrollmentModal() {
        this.setState({ showDualEnrollmentModal: true });
        this.showSecondaryTimer();
    }

    onDualEnrollmentModalHide() {
        this.setState({
            showDualEnrollmentModal: false,
            scheduleNextCallDate: null,
            scheduleNextCallSlot: null,
        });
    }

    onDualEnrollmentDeclineCcm() {
        this.setState({ showDualEnrollmentModal: false, showOptOut: true });
    }

    onDualEnrollmentComplete(result) {
        const { activeUser, patient, adminActions } = this.props;
        const updates = {};
        if (result && result.rpmEnrolled) {
            updates.rpmEnrollmentUiEnrolled = true;
            updates.rpmEnrollmentSummary = result.enrollmentSummary;
        }
        this.setState(updates);
        adminActions.getPatientDetail(patient.id);
        if (activeUser && activeUser.center && activeUser.center.ce_flag) {
            adminActions.getCnePerformance(this.props.userId);
        }
    }

    openEnrollModal(isDualEnrollmentEligible) {
        if (isDualEnrollmentEligible) {
            this.openDualEnrollmentModal();
        } else {
            this.setState({ showConfirmation: true });
        }
    }

    openRpmEnrollmentModal() {
        this.setState({ showRpmEnrollmentModal: true });
        this.showSecondaryTimer();
    }

    onRpmEnrollmentModalHide() {
        this.setState({
            showRpmEnrollmentModal: false,
            showRpmDeclineModal: false,
        });
        this.showSecondaryTimer();
    }

    openRpmDeclineModal() {
        this.setState({ showRpmDeclineModal: true });
        this.showSecondaryTimer();
    }

    onRpmDeclineBack() {
        this.setState({ showRpmDeclineModal: false });
        this.showSecondaryTimer();
    }

    onRpmEnrollmentComplete(summary) {
        this.setState({
            showRpmEnrollmentModal: false,
            showRpmEnrollmentCompleteModal: true,
            rpmEnrollmentUiEnrolled: true,
            rpmEnrollmentSummary: summary,
        });
        this.showSecondaryTimer();
    }

    onRpmEnrollmentCompleteModalHide() {
        this.setState({ showRpmEnrollmentCompleteModal: false });
        this.showSecondaryTimer();
    }

    onRpmEnrollmentDecline() {
        this.setState({
            showRpmEnrollmentModal: false,
            showRpmDeclineModal: false,
            rpmEnrollmentUiEnrolled: false,
            rpmEnrollmentSummary: null,
        });
        this.showSecondaryTimer();
    }

    onPopupHide() {
        this.setState({ show: false });
        this.showSecondaryTimer();
    }

    onReconsentPopupHide() {
        this.setState({ showReconsentModal: false });
        this.showSecondaryTimer();
    }

    onAutoCloseChartHide() {
        this.setState({ autoCloseChartShow: false })
        this.trackInactivity();
    }

    onAutoCloseChartShow() {
        this.setState({ autoCloseChartShow: true })
    }

    onOptionSelect(optionKey) {
        if (optionKey != 'newRecords') {
            var iframeLoading = false;
            if (optionKey == 'chartspan') {
                iframeLoading = true;
            }
            if (optionKey === 'rpmImpact') {
                openRpmImpactPopupSync();
            }
            this.setState({ selectedOption: optionKey, iframeLoading: iframeLoading });
            this.props.adminActions.openChartTab('');
        }


    }

    componentDidMount() {
        const { companies, user, activeUser } = this.props;
        const isUserAdmin = isAdmin(user.roles);
        let ce_flag, isRetSpec;
        const usesPrimaryChart = usesPrimaryChartAccess(activeUser, user.roles);
        if (activeUser && activeUser.center && activeUser.center.company_id) {
            ce_flag = activeUser.center.ce_flag;
            isRetSpec = activeUser.center.support_flag;
        }
        const isRPMUser = activeUser && activeUser.center && activeUser.center.rpm_flag;
        const isGAPSUser = activeUser && activeUser.center && activeUser.center.gaps_flag;
        const isRpmEnrollerUser = isRpmEnrollerClinicalCenter(activeUser, user.roles);
        if (this.props.activeUser && this.props.activeUser.center && (!isRPMUser && !isGAPSUser && !isRetSpec) ) {
            this.props.adminActions.getAssociatedCharts(this.props.patient.id);
        }
        this.props.adminActions.getPatientRecords(this.props.patient.id);
        this.props.adminActions.getGoalReviewFrequency();
        this.props.adminActions.getPatientCcmProiders(this.props.patient.id);
        if(!ce_flag && !isGAPSUser && !isRPMUser){
            this.props.adminActions.openChartSummary();
        }else{
            this.setState({showNotes:true});
        }
        if (usesPrimaryChart && !isRPMUser && !isGAPSUser && !ce_flag && !isRetSpec) {
            this.props.adminActions.getBillingInfo(this.props.patient.id, activeUser.id);
        }
        this.props.adminActions.getPatientServicesReasons();

        let company = null;
        if (activeUser && activeUser.center && activeUser.center.company_id) {
            company = _.result(_.find(companies, {'id':activeUser.center.company_id}), 'name');
            ce_flag = activeUser.center.ce_flag;
            isRetSpec = activeUser.center.support_flag;
        }
        const isGAPS = isGAPSUser;
        this.trackInactivity();
        this.checkMedSummaryAvailability();
        this.checkHealthSummaryAvailability();
        this.checkQualitySummaryAvailability();
        this.checkCCDAAvailability();
        this.loadPatientDetailForTimer(this.props.patient.id);
        this.props.adminActions.fetchGeneralNotes(this.props.patient.id);
        this.props.adminActions.checkProvider(this.props.patient.id);
        if (isUserAdmin && !ce_flag && companies) {
            this.props.notificationsAction.getPatientNotificationsUnreadCount(this.props.patient.id);
            this.props.notificationsAction.getPatientNotificationMessage(this.props.patient.provider_id, this.props.patient.id);
        }

        this.props.adminActions.getOptOutReasons();
        const activeWorkItemId = getPatientActiveWorkItemId(
            this.props.patient,
            this.props.activeUser,
            this.props.userRole
        );
        if (activeWorkItemId && usesPrimaryChartAccess(this.props.activeUser, this.props.userRole)) {
            this.props.adminActions.getPatientSurveyQuestion(activeWorkItemId);
            this.props.adminActions.getPatientSurveySubmission(activeWorkItemId);
        }
        if (this.props.patient.cs_userid) {
            this.props.adminActions.getLastPasswordReset(this.props.patient.id);
        }
        if (this.props.patient.provider.organization_id) {
            this.props.adminActions.getOrganizationNote(this.props.patient.provider.organization_id);
        }
        if(!isRPMUser && !isGAPS && !ce_flag){
            this.props.adminActions.getEngagementHistory(this.props.patient.id);     
        }
        if (!isRPMUser && !isGAPSUser && !isRetSpec) {
            this.props.adminActions.getRpmDeviceTypes();
        }
        
        if(isUserAdmin && !ce_flag && companies && this.props.patient.provider.integrated_notifications_enabled){
            this.props.notificationsAction.getPatientUnreadMessages(this.props.patient.provider.organization_id,
                this.props.patient.ehr_pid).catch(error => {
                    if(error?.message){
                        //  this.showMessage(error?.message,"Rincon Error");
                    }
            })
        }
        window.addEventListener('scroll', this.handleScroll);
    
    }

    componentWillUnmount() {
        this.removeInactivityTracking();
        this.props.adminActions.resetAssociatedCharts();
        this.props.notificationsAction.resetPatientCases();
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const prevPrimaryChart = usesPrimaryChartAccess(prevProps.activeUser, this.props.userRole);
        const nextPrimaryChart = usesPrimaryChartAccess(this.props.activeUser, this.props.userRole);
        if (prevProps.activeUser !== this.props.activeUser && prevPrimaryChart !== nextPrimaryChart) {
            if (nextPrimaryChart) {
                this.loadPatientDetailForTimer(this.props.patient.id);
            } else {
                this.setState({ patientDetailReady: false });
            }
        }
        if (this.props.patient && prevProps.patient && this.props.patient.id !== prevProps.patient.id) {
            this.loadPatientDetailForTimer(this.props.patient.id);
            this.setState({
                rpmEnrollmentUiEnrolled: false,
                rpmEnrollmentSummary: null,
                showRpmEnrollmentModal: false,
                showRpmDeclineModal: false,
                showRpmEnrollmentCompleteModal: false,
            });
        }
        const prevWorkItemId = getPatientActiveWorkItemId(
            prevProps.patient,
            this.props.activeUser,
            this.props.userRole
        );
        const nextWorkItemId = getPatientActiveWorkItemId(
            this.props.patient,
            this.props.activeUser,
            this.props.userRole
        );
        if (
            this.props.patient
            && prevProps.patient
            && nextWorkItemId
            && nextWorkItemId !== prevWorkItemId
            && usesPrimaryChartAccess(this.props.activeUser, this.props.userRole)
        ) {
            this.props.adminActions.getPatientSurveyQuestion(nextWorkItemId);
            this.props.adminActions.getPatientSurveySubmission(nextWorkItemId);
        }
        if (this.props.patient && this.props.patient.provider && prevProps.patient && prevProps.patient.provider &&
            this.props.patient.provider.organization_id !== prevProps.patient.provider.organization_id) {
            this.props.adminActions.getOrganizationNote(this.props.patient.provider.organization_id);
        }
        const cr = this.props.chartClosureRequested;

        if (cr && cr.showNotificationOfChartClosureRequest === true && this.state.showNotificationOfChartClosureRequestModal === false) {
            this.setState({
                showConfirmReset: this.props.app.showConfirmReset,
                formData: this.props.form,
                lastPasswordReset: this.props.levelTwoDashboard.lastPasswordReset || '',
                showNotificationOfChartClosureRequestModal: true,
            });
        } else if (cr && cr.showNotificationOfChartClosureRequest !== true) {
            // Requestor (or stale) chartClosureRequested: keep PCC notification modal closed and mirror props
            // into local state. Do NOT call setState when nothing changed — polling / unrelated updates
            // re-run componentDidUpdate and unconditional setState freezes the tab.
            const nextShowConfirmReset = this.props.app.showConfirmReset;
            const nextFormData = this.props.form;
            const nextLastPasswordReset = this.props.levelTwoDashboard.lastPasswordReset || '';
            const needsChartClosureSync =
                this.state.showNotificationOfChartClosureRequestModal === true ||
                this.state.showConfirmReset !== nextShowConfirmReset ||
                this.state.formData !== nextFormData ||
                this.state.lastPasswordReset !== nextLastPasswordReset;

            if (needsChartClosureSync) {
                this.setState({
                    showConfirmReset: nextShowConfirmReset,
                    formData: nextFormData,
                    lastPasswordReset: nextLastPasswordReset,
                    showNotificationOfChartClosureRequestModal: false,
                });
            }
        } else if (!cr && this.state.showNotificationOfChartClosureRequestModal) {
            this.setState({ showNotificationOfChartClosureRequestModal: false });
        }
        if (prevProps.generalNotes !== this.props.generalNotes) {
            this.setState({ notes: this.props.generalNotes.notes });
        }
        if (this.props.chartTabTobeOpen && this.props.chartTabTobeOpen !== prevProps.chartTabTobeOpen) {
            this.onOptionSelect(this.props.chartTabTobeOpen);
        }
        const pendingRpmEnrollPatientId = this.props.openRpmEnrollmentPatientId;
        if (
            pendingRpmEnrollPatientId
            && this.props.patient
            && this.props.patient.id === pendingRpmEnrollPatientId
            && (
                pendingRpmEnrollPatientId !== prevProps.openRpmEnrollmentPatientId
                || !prevProps.patient
                || prevProps.patient.id !== pendingRpmEnrollPatientId
            )
        ) {
            this.openRpmEnrollmentModal();
            this.props.adminActions.clearOpenRpmEnrollmentOnChartLoad();
        }
        const { completingRpmAlertTodoId } = this.state;
        if (completingRpmAlertTodoId && prevProps.todoLists !== this.props.todoLists) {
            const stillOpen = Object.values(this.props.todoLists || {})
                .some((todo) => todo.id == completingRpmAlertTodoId);
            if (!stillOpen) {
                this.setState({ completingRpmAlertTodoId: null });
            }
        }
    }

    onScheduleDateSelected = (date) => {
        this.setState({ scheduleNextCallDate: date });
    }

    onScheduleSlotSelected = (slot) => {
        this.setState({ scheduleNextCallSlot: slot });
    }

    checkMedSummaryAvailability = () =>
        this.props.adminActions.getMedSummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedMedSummary: true });
            });

    checkHealthSummaryAvailability = () =>
        this.props.adminActions.getHealthSummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedHealthSummary: true });
            });

    checkQualitySummaryAvailability = () =>
        this.props.adminActions.getQualitySummaryAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedQualitySummary: true });
            });

    checkCCDAAvailability = () =>
        this.props.adminActions.getCCDAAvailability(this.props.selectedPatient.id)
            .then(() => {
                this.setState({ hasCheckedCCDA: true });
            });

    handleScroll = () => {
        const fixedTimer = document.getElementById('fixed-timer');
        if (!fixedTimer) {
            return;
        }
        if (document.documentElement.scrollTop > 75) {
            fixedTimer.style.top = '50px';
            fixedTimer.style.zIndex = '10000';
        } else {
            fixedTimer.style.top = '-20px';
            fixedTimer.style.zIndex = '100';
        }
    }

    showSecondaryTimer = (isResetPassword = false) => {
        const setFixedTimerPosition = () => {
            const fixedTimer = document.getElementById('fixed-timer');
            if (!fixedTimer) {
                return;
            }
            if (this.state.showSecondaryTimer) {
                fixedTimer.style.top = '50px';
                fixedTimer.style.zIndex = '10000';
            } else if (document.documentElement.scrollTop < 75) {
                fixedTimer.style.top = '-20px';
                fixedTimer.style.zIndex = '100';
            }
        };

        if (isResetPassword) {
            this.setState({ showSecondaryTimer: !this.state.showSecondaryTimer, showConfirmReset: !this.state.showConfirmReset }, setFixedTimerPosition);
        }

        this.setState({ showSecondaryTimer: !this.state.showSecondaryTimer }, setFixedTimerPosition);
    }

    handleVerify = (address1, address2, city, state, zip_code, callType, ok_to_text, mobileNo) => {
        const { activeUser,patient } = this.props;
        const {scheduleNextCallSlot} = this.state;
        const isRPM = activeUser && activeUser.center && activeUser.center.rpm_flag;
        this.props.adminActions.verifyPatient(this.props.patient, callType,isRPM, patient.program_type === 'apcm')
            .then(() => {
                if (activeUser && activeUser.center && (activeUser.center.ce_flag || activeUser.center.rpm_flag)) {
                    this.props.adminActions.updateAddress(this.props.patient, address1, address2, city, state, zip_code, ok_to_text, mobileNo,()=>{
                        if(scheduleNextCallSlot){
                            this.props.adminActions.saveScheduleNextCall(patient.id,scheduleNextCallSlot.id);
                        }else{
                            this.props.adminActions.getPatientDetail(this.props.patient.id);
                        }

                        if(activeUser.center.rpm_flag){
                            this.props.adminActions.getRPMPerformance(this.props.userId);
                        }else if(activeUser.center.ce_flag){
                            this.props.adminActions.getCnePerformance(this.props.userId);
                        }

                    });
                }
                this.setState({ showConfirmation: false });
            });
    }

    handleEmailVerify = () => {
        this.props.adminActions.emailVerifyPatient(this.props.patient)
            .then(() => {
                const {activeUser} = this.props;
                this.props.adminActions.getPatientDetail(this.props.patient.id);
                if(activeUser.center.rpm_flag){
                    this.props.adminActions.getRPMPerformance(this.props.userId);
                }else if(activeUser.center.ce_flag){
                    this.props.adminActions.getCnePerformance(this.props.userId);
                }
                this.setState({ showEmailConfirmation: false });
            });
    }

    handleOptOut = (opt_out_id, optout_reason_id, notes) => {
        this.props.adminActions.optOutPatient(this.props.patient.id, opt_out_id, optout_reason_id, notes)
            .then(() => {
                const {activeUser} = this.props;
                this.props.adminActions.getPatientDetail(this.props.patient.id);
                if(activeUser.center.rpm_flag){
                    this.props.adminActions.getRPMPerformance(this.props.userId);
                }else if(activeUser.center.ce_flag){
                    this.props.adminActions.getCnePerformance(this.props.userId);
                }
                this.setState({ showOptOut: false });
            });
    }

    getTimeObject() {
        const millisecondsWorked = this.props.patient.work_millis_logged;
        const millisecondsRemaining = 1200000 - this.props.patient.work_millis_logged;
        let minutes = moment.duration(millisecondsRemaining).minutes();
        let seconds = moment.duration(millisecondsRemaining).seconds();
        let color = '#5cb85c';
        if (millisecondsWorked >= 900000 && millisecondsWorked < 1200000) {
            color = '#f0ad4e';
        } else if (millisecondsWorked >= 1200000) {
            color = '#d9534f';
        }

        let timeObject = {
            millisecondsWorked,
            minutes,
            seconds,
            color
        }

        return timeObject
    }

    trackInactivity() {
        if (!this.refs.levelTwoDashboard) return;
        try {
            ReactDOM.findDOMNode(this.refs.levelTwoDashboard);
        } catch (e) {
            return;
        }
        window.addEventListener("mousemove", this.resetTimer, false);
        window.addEventListener("mousedown", this.resetTimer, false);
        window.addEventListener("keypress", this.resetTimer, false);
        window.addEventListener("DOMMouseScroll", this.resetTimer, false);
        window.addEventListener("mousewheel", this.resetTimer, false);
        window.addEventListener("touchmove", this.resetTimer, false);
        window.addEventListener("MSPointerMove", this.resetTimer, false);

        this.startTimer();
    }

    startTimer() {
        this.idleSecondsInterval = setInterval(this.checkInactivityTimeOut, 1000);
    }

    checkInactivityTimeOut(e) {
        this.idleSecondsCounter++;
        if (this.idleSecondsCounter >= this.idleTimeOut) {
            this.removeInactivityTracking();
            this.onAutoCloseChartShow();
        }
    }

    resetTimer(e) {
        clearInterval(this.idleSecondsInterval);
        this.idleSecondsInterval = null;
        this.idleSecondsCounter = 0;
        this.startTimer();
    }

    stopTimer() {
        clearInterval(this.idleSecondsInterval);
        this.idleSecondsInterval = null;
        this.idleSecondsCounter = 0;
    }

    async handleMakeCall (testNumber, numberType = null){
        try {
        this.setCallStatus(`Initiating call to ${testNumber}...`, numberType);

        // Step 1: Get the user's org ID from the metadata endpoint
        let orgId = 1; // Default fallback
        // Fallback host if metadata doesn't give us a data-center-specific one below.
        // NOTE: this is the piece Five9 flagged as fixed/hard-coded — everything past
        // this point tries to replace it with the dynamic data center host instead.
        let apiHost = 'app.five9.com';
        try {
            const metadataResponse = await fetch('https://app.five9.com/appsvcs/rs/svc/auth/metadata', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                }
            });

            if (metadataResponse.ok) {
                const metadata = await metadataResponse.json();
                console.log("User metadata:", metadata);

                // The org ID might be in different fields depending on the API version
                if (metadata.orgId) {
                    orgId = metadata.orgId;
                } else if (metadata.tenantId) {
                    orgId = metadata.tenantId;
                } else if (metadata.userId) {
                    // Sometimes the userId contains org info
                    console.log("Using userId as potential org identifier:", metadata.userId);
                }

                // Use the data-center-specific host/port from metadata instead of the
                // hard-coded app.five9.com, so this keeps working after Five9 migrates
                // the account to a different data center. Safe/optional-chained since
                // the shape of this response isn't officially documented for us -
                // falls back to the hard-coded host above if anything is missing.
                const dynamicHost = metadata?.metadata?.dataCenters?.[0]?.apiUrls?.[0]?.host;
                const dynamicPort = metadata?.metadata?.dataCenters?.[0]?.apiUrls?.[0]?.port;

                if (dynamicHost) {
                    apiHost = dynamicPort ? `${dynamicHost}:${dynamicPort}` : dynamicHost;
                    console.log("Using dynamic data center host from metadata:", apiHost);
                } else {
                    console.warn("Metadata did not include a data center host (dataCenters[0].apiUrls[0].host); falling back to", apiHost);
                }
            } else {
                console.warn("Could not fetch metadata, using default orgId=1. Status:", metadataResponse.status);
            }
        } catch (metadataError) {
            console.warn("Could not fetch user metadata, using default orgId=1:", metadataError);
        }

        // Step 2: Make the click2dial API call
        const campaignName = "CEO ChartSpan Main 7877_8552427877";
        const apiUrl = `https://${apiHost}/appsvcs/rs/svc/orgs/${orgId}/interactions/click_to_dial?number=${encodeURIComponent(testNumber)}&campaignId=${encodeURIComponent(campaignName)}&dialImmediately=false`;
        
        try {
            const response = await fetch(apiUrl, {
            method: 'GET',
            credentials: 'include', // Important: include cookies for authentication
            headers: {
                'Accept': 'text/plain, */*',
            }
            });
            
            console.log("✅ REST API response status:", response.status);
            const contentType = response.headers.get('content-type');
            console.log("Response content-type:", contentType);
            
            if (response.ok) {
                // Try to parse as JSON, but handle text responses too
                let data;
                const responseText = await response.text();
                
                try {
                    data = JSON.parse(responseText);
                } catch {
                    data = responseText;
                }
                this.setCallStatus("✅ Call initiated successfully", numberType);
            } else if (response.status === 401) {
                this.showMessage("Not authenticated. Please log in to Five9 Agent Desktop in another tab.","Dial Error");
            } else if (response.status === 406) {
                this.showMessage("Campaign [" +campaignName+"] name may be incorrect or doesn't exist.","Dial Error");
            } else {
                const errorText = await response.text().catch(() => 'Unknown error');
                this.showMessage(`REST API error: ${response.status} - ${errorText}`,"Dial Error");
            }
        } catch (fetchError) {
            this.showMessage(`Network error: ${fetchError.message}. CORS may be blocking the request.`,"Dial Error");
        }
        } catch (error) {
            this.showMessage(`Error: ${error.message}`,"Dial Error");
        }
    }
    copyNumber(number, type) {
            const textArea = document.createElement("textarea");
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = 0;
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = number;
            document.documentElement.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.documentElement.removeChild(textArea);
            
            // Show "Copied" feedback
            this.setState({ copiedNumberType: type });
            setTimeout(() => {
                this.setState({ copiedNumberType: null });
            }, 500);
        }

    removeInactivityTracking() {
        if (this.refs.levelTwoDashboard) {
            try {
                ReactDOM.findDOMNode(this.refs.levelTwoDashboard);
            } catch (e) {
                // unmounted
            }
        }
        window.removeEventListener("mousemove", this.resetTimer, false);
        window.removeEventListener("mousedown", this.resetTimer, false);
        window.removeEventListener("keypress", this.resetTimer, false);
        window.removeEventListener("DOMMouseScroll", this.resetTimer, false);
        window.removeEventListener("mousewheel", this.resetTimer, false);
        window.removeEventListener("touchmove", this.resetTimer, false);
        window.removeEventListener("MSPointerMove", this.resetTimer, false);

        this.stopTimer();
    }

    makeCall(id, phone) {
        this.props.appActions.sentMakeCallRequest({ id, phone });
    }

    enableMergePatient() {
        let email = this.props.patient.email;
        let emailDomain = email && email.substr(email.indexOf("@") + 1);
        return emailDomain == 'patient.chartspan.com' ? false : true
    }

    handleSelectSessionNotes() {
        this.onOptionSelect('generalNotes');
    }

    togglePatientSatisfaction() {
        this.showSecondaryTimer();
        this.setState({ showPatientSatisfactionModal: !this.state.showPatientSatisfactionModal });
    }

    updatePatientSatisfaction(field, e) {
        this.setState({ [field]: e.target.value });
    }

    submitPatientSatisfaction() {
        if (this.state.satisfactionRating) {
            const { patient, patientSurveyQuestion } = this.props;
            const { satisfactionRating, satisfactionNotes } = this.state;
            if (satisfactionRating === 'decline' && !satisfactionNotes.trim()) {
                this.showMessage('You must add notes if selecting decline', 'Failure');
                return;
            }
            const cleanedSatisfactionRating = satisfactionRating === 'decline' ? null : satisfactionRating;
            this.props.adminActions.postPatientSurvey(patient.active_work_item_id, cleanedSatisfactionRating, satisfactionNotes, patientSurveyQuestion['id'])
                .then((response) => {
                    if (response === true) {
                        this.togglePatientSatisfaction();
                        this.props.adminActions.getPatientSurveySubmission(patient.active_work_item_id);
                    }
                });
        } else {
            this.showMessage('Select a satisfaction level', 'Failure');
        }
    }

    handleConfirmChartClosureRequested = () => {
        this.props.adminActions.removeRequestForChartClosure();
    };

    handlePatientStatusChange(newStatus, reason, notes) {
        if (newStatus === 'Active') {
            this.props.adminActions.supportToActive(this.props.patient.id)
                .then((response) => {
                    if (response === true) {
                        this.setState({ showPatientStatusUpdate: false });
                    }
                })
        } else if (newStatus === 'Pending Unenroll') {
            if (reason === 6 && !notes.trim()) {
                this.showMessage('When selecting "other," notes must be provided', 'Reason missing');
                return;
            }
            if (reason !== 6) {
                notes = "";
            }

            this.props.adminActions.supportToPendingUnenroll(this.props.patient.id, notes, reason)
                .then((response) => {
                    if (response === true) {
                        this.setState({ showPatientStatusUpdate: false });
                    }
                })
        }
    }

    showMessage(message, title = 'Invalid Value', status = 'error') {
        this.props.commonActions.showToast({
            status: status,
            title: title,
            message: message
        });
        var interval = setInterval(() => {
            clearInterval(interval);
            this.props.commonActions.hideToast();
        }, 2);
    }

    onEditPatientInfoShowHide() {
        this.showSecondaryTimer();
        this.setState({
            showEditPatientInfo: !this.state.showEditPatientInfo
        })
    }

    onRpmAlertCompletePopupHide = () => {
        this.showSecondaryTimer();
        this.setState({
            showRpmAlertCompleteTodo: false,
            rpmAlertCompleteTodoData: null,
            completingRpmAlertTodoId: null,
        });
    };

    handleCompleteRpmThresholdAlert = (alert) => {
        const { patient, activeUser } = this.props;
        if (!patient || !alert) {
            return;
        }
        const todoId = alert.todo_id || alert.id;
        if (!todoId) {
            return;
        }
        const dataObj = { [todoId]: true };
        const ceFlag = activeUser && activeUser.center && activeUser.center.ce_flag;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        const urgent = alert.urgent != null ? alert.urgent : true;

        if (urgent && activeUser && activeUser.center && !ceFlag && !isRetSpec) {
            this.showSecondaryTimer();
            this.setState({
                showRpmAlertCompleteTodo: true,
                rpmAlertCompleteTodoData: dataObj,
                completingRpmAlertTodoId: todoId,
            });
            return;
        }

        this.setState({ completingRpmAlertTodoId: todoId });
        this.props.adminActions.markComplete(patient.id, dataObj);
    };

    getUrgentChips(){
        const chips = [];
        let todoLists = this.props.todoLists || [];
        const dischargedMgmt = _.values(todoLists).find(urgent => urgent.urgent_todo_type_id == 25);
        if(dischargedMgmt){
             const {urgentTypes} = this.props;
            const urgentTypeKeyValue = {};
            _.each(urgentTypes,(urgentType) => {
                urgentTypeKeyValue[urgentType.id] = urgentType.name;
            });
            return <div key={25} className="new-patient-status" style={{fontWeight:400,marginRight:15,background:'#FFFFFF',
                    border:'2px solid rgb(222,159,53)',padding:4, fontSize:14}}>
                    {urgentTypeKeyValue[25+'']}
                </div>
        }
        return null;
       
    }

    render() {
        const { hasCheckedMedSummary, hasCheckedCCDA, hasCheckedHealthSummary, hasCheckedQualitySummary } = this.state;
        const { patient, user, userRole, activeUser, ccdaAvailable, medSummaryAvailable, healthSummaryAvailable, qualitySummaryAvailable, patientSurveySubmitted, patientSurveyQuestion, organizationNote, associatedCharts, currentQueue,
            call_preference_description,engagementHistory,patientServicesReasons, selectedPatientChangeProvider, licensedUser } = this.props;
        const isCne = activeUser && activeUser.center && activeUser.center.ce_flag;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        const isRPMUser = activeUser && activeUser.center && activeUser.center.rpm_flag;
        const isGAPSUser = activeUser && activeUser.center && activeUser.center.gaps_flag;
        const isRpmEnrollerUser = isRpmEnrollerClinicalCenter(activeUser, user.roles);
        const showRpmEnrollInChart = hasRpmEnrollInChartUx(activeUser, user.roles);
        const showWorkTimer = usesPrimaryChartAccess(activeUser, user.roles);
        const isMAUser = isMA(userRole);
        const isPCAUser = isPCA(user.roles);
        const isUserAdmin = isAdmin(userRole);
        const isTriageUser = isTriage(userRole);
        const today = moment();
        let isButtonsAvailable = false;
        let loadNoteNeeded = false;

        const changePorviderName = selectedPatientChangeProvider?.requested_provider_name;

        let isSupportReasonAvailable = patient && patient.support_reason_id && 
            (((patient.from_support || patient.status === PATIENT_STATUS_SUPPORT)&& patient.program_type !== 'pathways_stroke_care') && 
            (isRetSpec || (!isRPMUser && !isGAPSUser && !isCne && !isRetSpec)));
        let supportReason = "";
        if(isSupportReasonAvailable && patientServicesReasons){
            //support_reason_id
            const reasonObject = _.find(patientServicesReasons,(reason) => reason.id == patient.support_reason_id);
            supportReason = reasonObject ? reasonObject.reason : "-";
        }
        const hidePatientSatisfaction =
            patient.status === PATIENT_STATUS_NEW ||
            isCne ||
            patient.show_nps === false ||
            patient.first_time_active_ts === null ||
            (patient.latest_survey_submission_ts !== null && today.diff(moment(this.props.patient.latest_survey_submission_ts), 'days') < 90) ||
            (patient.first_time_active_ts && today.diff(moment(this.props.patient.first_time_active_ts), 'days') < 90);
        const showVerifyButton =
            (patient.status === PATIENT_STATUS_NEW && !isCne) ||
            patient.status === PATIENT_STATUS_UNVERIFIED ||
            patient.status === PATIENT_STATUS_AE_APPROVED ||
            patient.status === PATIENT_STATUS_OPTED_OUT ||
            patient.status === PATIENT_STATUS_RPM_UNVERIFIED;
        const showOptOutButton =
            patient.status === PATIENT_STATUS_UNVERIFIED ||
            patient.status === PATIENT_STATUS_AE_APPROVED ||
            patient.status === PATIENT_STATUS_OPTED_OUT ||
            patient.status === PATIENT_STATUS_RPM_UNVERIFIED;
        const isDualEnrollmentEligible = isCne
            && !isRPMUser
            && patient.rpm_addon_status_id === RPM_ADDON_STATUS_ELIGIBLE
            && showVerifyButton;
        const dualProgramShortLabel = patient.program_type === 'apcm' ? 'APCM' : 'CCM';
        const dualEnrollButtonText = `Enroll in ${dualProgramShortLabel} + RPM`;
        const showSummaryEnrollButton = showVerifyButton && !isDualEnrollmentEligible && !isRpmEnrollerUser;
        const showSummaryDeclineButton = showOptOutButton && !isDualEnrollmentEligible && !isRpmEnrollerUser;
        const showEmailCneAddButton =
            (patient.status === PATIENT_STATUS_UNVERIFIED ||
                patient.status === PATIENT_STATUS_AE_APPROVED) &&
            isCne && isUserAdmin;
        const isRapidEval = patient && patient.provider && patient.provider.organization_rapid_eval;
        const messagesAvailable = patient && patient.provider && patient.provider.integrated_notifications_enabled;
        const isTextClinical = patient && patient.provider && patient.provider.text_clinical;
        const declineButtonText = isCne || isRPMUser ? 'Decline' : 'Opt Out';
        const confirmButtonText = isCne || isRPMUser ? 'Enroll' : 'Verify';
        const isSpecialty = patient && patient.provider && patient.provider.specialty_id !== 1;
        const isOrgFrozen = patient && patient.provider && patient.provider.organization_frozen;

        const disableButtonForFrozenOrg = isCne && isOrgFrozen;

        const ok_to_text = patient.ok_to_text;
        const ok_to_text_ts = patient.ok_to_text_ts;
        const sms_consent = patient.sms_consent;
        const sms_consent_ts = patient.sms_consent_ts;
        let okToTextValue = "";
        let dateString = "";
        let smsDateString = "";
        if (ok_to_text_ts) {
            dateString = moment.utc(ok_to_text_ts).local().format('MM/DD/YYYY');
        }
        if (sms_consent_ts) {
            smsDateString = moment.utc(sms_consent_ts).local().format('MM/DD/YYYY');
        }

        if (ok_to_text === null) {
            okToTextValue = "N/A";
        } else if (ok_to_text !== null && sms_consent === "duplicate_number") {
            okToTextValue = "Ineligible (Duplicate)";
        } else if (ok_to_text === 0) {
            okToTextValue = `No - ${dateString}`;
        }
        else if (ok_to_text === 1) {
            if(dateString){
                okToTextValue = `Yes - ${dateString}`;
            }else{
                okToTextValue = `Yes`;
            }
            
        }else if (ok_to_text === 1 && sms_consent.toLowerCase() === "false") {
            okToTextValue = `No - SMS decline - ${smsDateString}`;
        }

        if (!isRpmEnrollerUser && (showEmailCneAddButton || showSummaryEnrollButton
            || showSummaryDeclineButton || isRetSpec)) {
            isButtonsAvailable = true;
        }

        let outboundNumber = config.CE_OUTBOUND_NUMBER;
        const location_outbound_number = patient && patient.provider && patient.provider.location_outbound_number;
        const organization_outbound_number = patient && patient.provider && patient.provider.organization_outbound_number;
        if (location_outbound_number) {
            outboundNumber = location_outbound_number;
        } else if (organization_outbound_number) {
            outboundNumber = organization_outbound_number;
        }

        let outboundClinicalNumber = config.CLINICAL_OUTBOUND_NUMBER;
        const location_outbound_clinical_number = patient && patient.provider && patient.provider.location_clinical_outbound_number;
        const organization_clinical_outbound_number = patient && patient.provider && patient.provider.organization_clinical_outbound_number;
        if (location_outbound_clinical_number) {
            outboundClinicalNumber = location_outbound_clinical_number;
        } else if (organization_clinical_outbound_number) {
            outboundClinicalNumber = organization_clinical_outbound_number;
        }

        let scheduleNextCall = '-';
        let scheduleNextLocalTimeCall = 'Schedule Next Call';
        let showScheduleNextCallInRed = false;
        const call_scheduled_slot_id = patient.call_scheduled_slot_id;
        if(call_scheduled_slot_id == 0){
            scheduleNextCall = 'Patient has no call preference'
        }else if (patient.call_scheduled_ts) {
            const scheduleTS = moment(patient.call_scheduled_ts);
            const currentESTTime = moment(patient.current_est_time);
            if(scheduleTS.isBefore(currentESTTime)
                && scheduleTS.isSame(currentESTTime,'year')
                && scheduleTS.isSame(currentESTTime,'month')){
                showScheduleNextCallInRed = true;
                scheduleNextCall = moment(patient.call_scheduled_ts).format('MM/DD/YYYY hh:mm a')
            }else if(!scheduleTS.isBefore(patient.current_est_time)) {
                scheduleNextCall = moment(patient.call_scheduled_ts).format('MM/DD/YYYY hh:mm a')
                scheduleNextLocalTimeCall = moment(patient.call_scheduled_ts_patient_tz).format('MM/DD/YYYY hh:mm a')
            }
        }

        if(!patient.schedulable){
            scheduleNextCall = 'Patient declines scheduling'
            scheduleNextLocalTimeCall = 'Patient declines scheduling'
        }
        const displayValue = isCne && scheduleNextCall == '-' ? 'none' : 'block';

        let programType = '-';
        if(isRPMUser){
            programType = 'Remote Monitoring'
        }else if(patient.program_type !== 'ccm'){
            programType = patient.program_type  == 'pathways_stroke_care' ? 'Pathways-Stroke' : '-';
        }else{
            let cptCode = '';
            if(patient.provider.location_billing_code){
                cptCode = patient.provider.location_billing_code;
            }else{
                cptCode = patient.provider.organization_billing_code
            }
            if(cptCode == "99490"){
                programType = 'Standard CCM'
            }else if(cptCode == "G0511"){
                programType = 'RHC/FQHC'
            }
        }
        let lastVisitedDate = '-';
        if(patient && patient.last_visit_date){
            lastVisitedDate = moment(patient.last_visit_date).format('MM/DD/YYYY');
        }
        const clinicalServiceGoal = patient && patient.provider && patient.provider.clinical_service_goal;
        const serviceGoalValue = clinicalServiceGoal != null && clinicalServiceGoal !== ''
            ? clinicalServiceGoal
            : '-';

        const latest_checkout_ts = patient.latest_checkout_ts;
        const latest_checkin_ts = patient.latest_checkin_ts;
        const inAutoDial = isAutoDial(latest_checkout_ts,latest_checkin_ts)

        const clinicalUser = !isCne && !isGAPSUser && !isRPMUser ;

        if(!isCne && !isGAPSUser && !isRPMUser && !isRetSpec && !isMAUser && !isPCAUser){
            loadNoteNeeded = true;
        }

        let apcmCandidate = false;
        let apcmPatient = false;
        let topProgramChip = '';
        let direction = "";
        if(patient.apcm_level_change){
            if(patient.apcm_service_level > patient.apcm_eligible_level){
                direction = "↓";
            }else if(patient.apcm_service_level < patient.apcm_eligible_level){
                direction = "↑";
            }else{
                direction = "";
            }
        }
        if(patient.program_type === 'apcm'){
            if(patient.apcm_service_level){
                topProgramChip = 'APCM Level '+patient.apcm_service_level;
            }else if(patient.apcm_eligible_level){
                topProgramChip = 'APCM Level '+patient.apcm_eligible_level;
            }else{
                topProgramChip = 'APCM';
            }
            apcmPatient = true;
        }else if(patient.program_type === 'ccm' ){
            if(patient.apcm_enrollment === 'Candidate' && patient.apcm_eligible_level){
                apcmCandidate = true;
            }       
            topProgramChip = 'CCM'
        }

        const showTimerSummaryColumn = showWorkTimer || apcmCandidate || apcmPatient;
        const enrollerSummaryThirdColumn = isRpmEnrollerUser && !showWorkTimer;
        const enrollerWideSummaryLayout = enrollerSummaryThirdColumn && showTimerSummaryColumn;
        const summaryNarrowFlex = showWorkTimer ? 0.25 : (enrollerWideSummaryLayout ? 0.25 : 1);
        const summaryWideFlex = showWorkTimer ? 0.5 : (enrollerWideSummaryLayout ? 0.5 : 1);
        const enrollerSummaryItemBoxLayoutStyle = { float: 'none', width: 'auto' };
        const summaryProviderPanelStyle = enrollerSummaryThirdColumn
            ? { flex: '1 1 0', minWidth: 0, ...enrollerSummaryItemBoxLayoutStyle }
            : (showWorkTimer
                ? { width: '100%' }
                : { flex: 1, width: 'auto', minWidth: 0 });
        const summaryActionsPanelStyle = enrollerSummaryThirdColumn
            ? { flex: '0 0 220px', minWidth: 220, ...enrollerSummaryItemBoxLayoutStyle }
            : (showWorkTimer
                ? { width: '100%' }
                : { flex: '0 0 280px', width: 'auto', minWidth: 280 });
        const summaryActionsInnerStyle = showWorkTimer
            ? { width: '100%', margin: 0, position: 'absolute' }
            : { width: '100%', margin: 0, position: 'static', padding: '10px 8px', boxSizing: 'border-box' };

        const isClinicalOrSupportChartUser = !isCne && !isGAPSUser && !isRPMUser;
        const patientIsRpmAddonEligible = patient.rpm_addon_status_id === RPM_ADDON_STATUS_ELIGIBLE
            && !this.state.rpmEnrollmentUiEnrolled;
        const patientRpmAddonNewOrActive = patient.rpm_addon_status_id === RPM_ADDON_STATUS_NEW
            || patient.rpm_addon_status_id === RPM_ADDON_STATUS_ACTIVE;
        /** RPM/Impact tab + enrolled banner — clinical/support; New/Active or just completed enroll in this session. */
        const showRpmEnrolled = isClinicalOrSupportChartUser && (
            this.state.rpmEnrollmentUiEnrolled
            || patientRpmAddonNewOrActive
        );
        const showDualRpmEnrolled = isCne && !isRPMUser && (
            this.state.rpmEnrollmentUiEnrolled
            || patient.rpm_addon_status_id === RPM_ADDON_STATUS_NEW
            || patient.rpm_addon_status_id === RPM_ADDON_STATUS_ACTIVE
        );
        const showDualRpmEligible = isDualEnrollmentEligible && !showDualRpmEnrolled;
        const showRpmEligibleBanner = patientIsRpmAddonEligible && !showDualRpmEligible;
        const showRpmEnrollerEnrollAction = showRpmEnrollInChart && showRpmEligibleBanner;
        const showAnyRpmEnrolled = showRpmEnrolled || showDualRpmEnrolled;
        const showAnyRpmEligible = showRpmEligibleBanner || showDualRpmEligible;
        /** Chart RPM threshold alerts (APP-3772): only when RPM add-on is New or Active. */
        const showRpmThresholdChartAlerts = this.state.rpmEnrollmentUiEnrolled
            || patient.rpm_addon_status_id === RPM_ADDON_STATUS_NEW
            || patient.rpm_addon_status_id === RPM_ADDON_STATUS_ACTIVE;
        const rpmDeviceTypeLabel = getRpmDeviceTypeLabel(this.props.rpmDeviceTypes, patient.rpm_device_type_id);
        const rpmDiagnosisDisplay = patient.rpm_icd10code
            ? [patient.rpm_icd10code, patient.rpm_icd10code_desc].filter(Boolean).join(' — ')
            : null;
        const rpmEnrollmentSummary = this.state.rpmEnrollmentSummary;
        const rpmStatusLabel = patient.rpm_addon_status_id === RPM_ADDON_STATUS_ACTIVE && !this.state.rpmEnrollmentUiEnrolled
            ? 'RPM Active'
            : 'RPM New';

        const apcmProgramSummaryBlock = (apcmCandidate || apcmPatient) ? (
            <div
                className="value-box"
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderTop: '1px solid #BDBDBD',
                    paddingTop: apcmPatient ? 15 : 0,
                    marginTop: enrollerSummaryThirdColumn ? 10 : 0,
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 600 }}>APCM Program</div>
                {!isCne && (
                    <div style={{ display: 'flex', justifyContent: 'flex-start', padding: 10, paddingBottom: 0 }}>
                        <span style={{ fontWeight: 600 }}>APCM Service Level:</span>
                        <span style={{ paddingLeft: 15 }}>{patient.apcm_service_level ? patient.apcm_service_level : '-'}</span>
                    </div>
                )}
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    padding: 10,
                    paddingBottom: 0,
                    color: patient.apcm_level_change ? 'red' : 'inherit',
                    fontWeight: patient.apcm_level_change ? 600 : 'normal',
                }}>
                    <span style={{
                        fontWeight: patient.apcm_level_change ? 600 : 400,
                        fontStyle: 'italic',
                    }}>APCM Eligible Level:</span>
                    <span style={{
                        paddingLeft: 15,
                        fontStyle: 'italic',
                        fontWeight: patient.apcm_level_change ? 600 : 'normal',
                    }}>{patient.apcm_eligible_level ? patient.apcm_eligible_level : '-'}</span>
                    <span style={{ paddingLeft: 10, marginTop: -2, fontStyle: 'italic', color: '#000000' }}>{direction}</span>
                </div>
            </div>
        ) : null;

        return (
            <div ref="levelTwoDashboard">
                <PageHeader style={{display:'flex', alignItems:'center'}}>
                    <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                        <div>
                        {isSpecialty ?
                            <span style={{ color: 'red' }}>{patient.provider.specialty_description} </span>
                            :
                            <span style={{paddingRight:5}}>Primary Care </span> }Chart
                        {
                            patient.reconsent && <span style={{ color: '#FF0000' ,paddingLeft:15,fontWeight:400}}>Patient Requires Re-Consent</span>
                        }
                        {
                            patient.apcm_level_change && <span style={{ color: '#FF0000' ,paddingLeft:15,fontWeight:400}}>APCM Level Change - Consent Required</span>
                        }
                        {
                           (licensedUser !== null && licensedUser === false) && <span style={{ color: '#FF0000' ,paddingLeft:15,fontWeight:400}}>
                               <span style={{ color: '#FF0000' ,paddingLeft:15,fontWeight:600}}>STATE LICENSE REQUIREMENT NOT MET - </span> Activity will be non-billable
                            </span>
                        }
                        {
                                !isCne && apcmCandidate && <span style={{ color: "red", marginLeft: '10px' }}> APCM Program Consent - Level {patient.apcm_eligible_level ? patient.apcm_eligible_level : '-'}</span>
                        }
                        {
                                showAnyRpmEligible && <span style={{ color: '#067809', marginLeft: '10px', fontWeight: 600 }}>RPM Eligible</span>
                        }
                        {
                                isRPMUser && <span style={{ color: "red", marginLeft: '10px' }}> RPM Patient</span>
                        }
                        {
                        isRapidEval ?
                                <span style={{ color: "red", marginLeft: '10px' }}> RAPID EVAL PATIENT - RAPID EVAL PATIENT - RAPID EVAL PATIENT</span>
                                : ''}
                        {patient.from_support && patient.program_type !== 'pathways_stroke_care' ?
                            <span style={{ color: "red", marginLeft: '10px' }}> RECENTLY IN PATIENT SERVICES</span> :
                            !patient.from_support && patient.program_type == 'pathways_stroke_care' ?
                                <span style={{ color: "red", marginLeft: '10px' }}> Pathways - Stroke Care</span>
                                : patient.from_support && patient.program_type == 'pathways_stroke_care' ?
                                    <span style={{ color: "red", marginLeft: '10px' }}> Pathways - Stroke Care | RECENTLY IN PATIENT SERVICES</span>
                                    :
                                    ''}
                        {
                            !isGAPSUser && isCne && !isRPMUser && !isRetSpec && patient.re_engaged && <span
                            style={{
                            margin: "0 15px",
                            border: "2px solid rgb(213, 161, 76)",
                            padding: "6px",
                            borderRadius: 30,
                            background: "rgb(228, 228, 228)",
                            fontSize: 12,
                            fontWeight: 600,
                            }}
                        >
                            Re-engage
                        </span>
                        }   
                        </div>
                        <div style={{display:'flex',justifyContent:'center', alignItems:'center'}}>
                            {
                                this.getUrgentChips()
                            }
                            {
                                topProgramChip && <div style={{
                                    background:topProgramChip === 'CCM'  ?'#337ab7' : '#5cb85c', 
                                    border:topProgramChip === 'CCM' ? '1px solid #337ab7' : '1px solid #5cb85c', borderRadius:20, padding: '5px 12px',
                                    fontWeight:400,
                                    fontSize: 14,
                                    color: '#FFFFFF',
                                    marginRight: showAnyRpmEnrolled ? 8 : 0,
                                }}>
                                        {topProgramChip}
                                </div>
                            }
                            {
                                showAnyRpmEnrolled && <div style={{
                                    ...getRpmEligibleChipStyle(),
                                    fontSize: 14,
                                    padding: '5px 12px',
                                }}>
                                    {rpmStatusLabel}
                                </div>
                            }
                            
                        </div>
                    </div>
                             
                </PageHeader>
                {showWorkTimer &&
                <div
                    style={{
                        position: 'fixed',
                        top: '-20px',
                        right: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '70px',
                        width: '170px',
                        background: 'rgb(230,230,230)',
                        boxShadow: '-1px 1px 2px rgba(0,0,0,.3)',
                        borderBottomLeftRadius: '2px',
                        zIndex: 100,
                        transition: 'top 200ms',
                    }}
                    id="fixed-timer"
                >
                    <WorkLoggedCell
                        data={patient}
                        timerActive={this.state.patientDetailReady}
                        timerNeeded={true}
                    />
                </div>
                }

                <div className="disabledContainer">
                    <div>
                        <div style={{display:"flex"}} className="patient-summary-box">
                            <div style={{ flex: summaryNarrowFlex, borderRight:'1px solid #BDBDBD' }}>
                                <div className="patient-summary-item-box" style={{ width: '100%', borderRight:'none' }}>
                                    <div style={{ clear: 'both', textAlign: 'left' }} className="clearfix">
                                        <div className="value-box"
                                            style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Name:</span> {patient.first_name + ' ' + patient.last_name}
                                            {isRPMUser && <span style={{fontWeight:'bold'}}> (RPM Patient)</span>}
                                        </div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }} className="clearfix">
                                        <div className="value-box"
                                            style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Gender:</span> {patient.gender ? patient.gender : 'N/A'} </div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>DOB:</span> {moment(patient.date_of_birth).format('MM/DD/YYYY') + ', Age:' + patient.age}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Language:</span> {patient.preferred_language}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>CCM ID:</span> {patient.id}</div>
                                    </div>
                                    {
                                        isCne &&
                                        <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Outbound Number: </span>
                                                {numberToPhone(outboundNumber)}</div>
                                        </div>
                                    }

                                    {
                                        !isCne &&  !isRetSpec &&
                                        <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Outbound Number: </span>
                                                {numberToPhone(outboundClinicalNumber)}</div>
                                        </div>
                                    }

                                    {!showOptOutButton &&
                                        <div style={{ clear: 'both', textAlign: 'left' }} className="clearfix">
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Enrolled: </span>{moment.utc(patient.billing_eligible_ts).local().format('MM/DD/YYYY')}</div>
                                        </div>
                                    }
                                    <div style={{ clear: 'both', textAlign: 'left' }} className="clearfix">
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Consent Type : </span>
                                        {getConsentTypeLabel(patient)}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Email:</span> {patient.email}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left', marginBottom: '3px' }} className="clearfix">
                                        <div style={{display:'flex', justifyContent:'space-between'}}>
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>ZIP Code:</span> {patient.zip_code || 'N/A'}</div>
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>State:</span> {patient.state || 'N/A'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: summaryNarrowFlex, borderRight:'1px solid #BDBDBD' }}>
                                <div className="patient-summary-item-box" style={{ width: '100%', borderRight:'none' }}>
                                    {
                                        !isRPMUser && <div>
                                            <div style={{ clear: 'both', textAlign: 'left' ,display:displayValue}}>
                                                <div className="value-box"
                                                    style={{ width: '100%' }}>
                                                    <span style={{ fontWeight: 'bold',paddingRight:5 }}>
                                                        ChartSpan Appointment Time:
                                                    </span>
                                                    <span style={{color:showScheduleNextCallInRed && 'red'}}>
                                                        {`${showScheduleNextCallInRed ? '(Last Appt) ' : ''}${scheduleNextCall}`}
                                                    </span>
                                                </div>

                                            </div>
                                            <div style={{ clear: 'both', textAlign: 'left',display:displayValue }}>
                                                <div className="value-box" style={{ width: '100%' }}>
                                            <span style={{ fontWeight: 'bold' }}>
                                                Local Patient Appointment Time:</span>
                                                    {
                                                        !patient.schedulable ?
                                                            <span style={{paddingLeft:5}}>
                                                                {scheduleNextLocalTimeCall}
                                                            </span>
                                                            :
                                                            <Button bsStyle="link" onClick={() => this.setState({ showScheduleNextCall: true })} style={{ padding: 0, paddingLeft: 5, outline: 'none' }}>
                                                                {scheduleNextLocalTimeCall}
                                                            </Button>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    }


                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Practice Time Zone:</span> {patient.provider && patient.provider.local_time_zone ? patient.provider.local_time_zone : '-'}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Phone:</span> {(patient.phone) ?

                                            <div style={{ display: 'inline-block' }} onClick={this.handleMakeCall.bind(this, patient.phone, 'phone')}>
                                                <span style={{ position: 'relative', display: 'inline-block' }}>
                                                    <Button bsStyle="link" style={{ padding: 0, outline: 'none' }}>{numberToPhone(patient.phone)}</Button>
                                                    {this.state.copiedNumberType === 'phone' && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: 'rgba(40, 167, 69, 0.9)',
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderRadius: '3px',
                                                            fontWeight: 'bold',
                                                            fontSize: '12px',
                                                            zIndex: 1000,
                                                            pointerEvents: 'none'
                                                        }}>
                                                            Copied
                                                        </div>
                                                    )}
                                                </span>
                                                {(patient.mobile_preferred === 0 && patient.phone) ? <span className="fa fa-asterisk" style={{ verticalAlign: 'super', fontSize: '5px', color: '#ff0000' }}></span> : ''}
                                                <OverlayTrigger trigger={['hover', 'focus']} placement='top'
                                                    overlay={<Popover id="popover-trigger-hover-focus">
                                                        <span>Copy</span>
                                                    </Popover>}>
                                                    <i style={{ marginLeft: 10, cursor:'pointer' }} className="fa fa-clipboard" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.copyNumber(patient.phone, 'phone'); }}></i>
                                                </OverlayTrigger>
                                                {this.state.callStatusByNumber && this.state.callStatusByNumber.phone && (
                                                    <span style={{ 
                                                        marginLeft: 10, 
                                                        color: '#007bff', 
                                                        fontSize: '12px',
                                                        fontWeight: 'normal'
                                                    }}>
                                                        {this.state.callStatusByNumber.phone}
                                                    </span>
                                                )}
                                                
                                            </div>

                                            : 'N/A'}

                                            {
                                                inAutoDial && <div style={{color:'#f52b04',display:'inline-block',marginLeft:10}}>
                                                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                                <span style={{fontSize:12,paddingLeft:5}}>In Autodial Queue</span>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}>
                                            <span style={{ fontWeight: 'bold' }}>Last called: </span>
                                            {patient.last_call_ts
                                                ? moment.utc(patient.last_call_ts).local().format('h:mma MM/DD/YYYY')
                                                : 'N/A'
                                            }
                                        </div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}>
                                            <span style={{ fontWeight: 'bold' }}>Mobile: </span>
                                            {(patient.mobile) ?
                                                 <div style={{ display: 'inline-block' }} onClick={this.handleMakeCall.bind(this, patient.mobile, 'mobile')}>
                                                    <span style={{ position: 'relative', display: 'inline-block' }}>
                                                        <Button bsStyle="link" style={{ padding: 0, outline: 'none' }}>
                                                                {numberToPhone(patient.mobile)}</Button>
                                                        {this.state.copiedNumberType === 'mobile' && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                backgroundColor: 'rgba(40, 167, 69, 0.9)',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: '3px',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px',
                                                                zIndex: 1000,
                                                                pointerEvents: 'none'
                                                            }}>
                                                                Copied
                                                            </div>
                                                        )}
                                                    </span>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement='top'
                                                        overlay={<Popover id="popover-trigger-hover-focus">
                                                            <span>Copy</span>
                                                        </Popover>}>
                                                        <i style={{ marginLeft: 10, cursor:'pointer' }} className="fa fa-clipboard" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.copyNumber(patient.mobile, 'mobile'); }}></i>
                                                    </OverlayTrigger>
                                                    {(patient.mobile_preferred === 1 && patient.mobile) ?
                                                        <span className="fa fa-asterisk" style={{ verticalAlign: 'super', fontSize: '5px', color: '#ff0000' }}></span> : <span> </span>}
                                                    {this.state.callStatusByNumber && this.state.callStatusByNumber.mobile && (
                                                        <span style={{ 
                                                            marginLeft: 10, 
                                                            color: '#007bff', 
                                                            fontSize: '12px',
                                                            fontWeight: 'normal'
                                                        }}>
                                                            {this.state.callStatusByNumber.mobile}
                                                        </span>
                                                    )}
                                                </div> : 'N/A'}&nbsp;
                                            
                                </div>
                                    </div>
                                    {isTextClinical && !isRPMUser && !isCne && !isRetSpec &&
                                        <div style={{ clear: 'both', textAlign: 'left' }}>
                                            <div className="value-box" style={{ width: '100%' }}>
                                                <span style={{ fontWeight: 'bold' }}>Ok to Text: </span>
                                                {
                                                    okToTextValue !== 'N/A' ? okToTextValue
                                                        :
                                                        <button
                                                            type="button"
                                                            disabled={!isTextClinical}
                                                            className="btn btn-success"
                                                            style={{ padding: '2px 12px', marginLeft: 15 }}
                                                            onClick={this.onEditPatientInfoShowHide.bind(this)}
                                                        >
                                                            Text Consent
                                            </button>
                                                }

                                            </div>
                                        </div>
                                    }

                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Insurance 1:</span> {patient.insurance1 || 'N/A'}
                                        </div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Insurance 2:</span> {patient.insurance2 || 'N/A'}</div>
                                    </div>
                                    <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>Shared Chart:</span> {patient.profile_shared ? 'Yes' : 'No'}</div>
                                    </div>

                                   
                                    {(isCne || (!isRPMUser && !isGAPSUser && !isRetSpec && !isCne)) &&
                                        <div style={{ clear: 'both', textAlign: 'left' }}>
                                            <div className="value-box" style={{ width: '100%' }}>
                                                <span style={{ fontWeight: 'bold' }}>
                                                Last Visit Date:</span> {lastVisitedDate || '-'}
                                            </div>
                                        </div>
                                    }
                                    {/* <div className="value-box" style={{ textAlign: 'center', marginTop: '-2px', cursor: 'pointer' }}>
                                        <div className="btn-link" onClick={() => clinicalUser ? 
                                        this.props.adminActions.openChartSummary(): this.setState({showNotes:true})}>View Chart Summary</div>
                                    </div> */}
                                    {/* <div style={{ textAlign:"left",clear:'both', padding: isSupportReasonAvailable && 10, borderTop: isSupportReasonAvailable ? '1px solid #BDBDBD' : '' }}>
                                            <span style={{fontWeight:600}}>Support Reason:</span>
                                    </div> */}
                                     <div style={{ clear: 'both', textAlign: 'left' }}>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement='top' overlay={this.popoverHoverFocus(patient.poa_name ? patient.poa_name : '')}>
                                            <div className="value-box" style={{ width: '100%' }}><span style={{ fontWeight: 'bold' }}>POA:</span> 
                                                <div>{patient.poa_name ? patient.poa_name : '-'}</div>
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                flex: summaryWideFlex,
                                display: 'flex',
                                minWidth: 0,
                                ...(enrollerSummaryThirdColumn ? { alignItems: 'stretch' } : {}),
                            }}>
                            <div className="patient-summary-item-box" style={summaryProviderPanelStyle}>
                              <div className="value-box" style={{ width: '100%', textAlign: 'center' }}>
                                    {
                                        disableButtonForFrozenOrg ?
                                            <div style={{ color: '#d43f3a', borderRadius: 4,fontWeight: 'bold'  }}>
                                                <span>
                                                    {patient.provider ? patient.provider.organization : ""}
                                                    <span style={{ paddingLeft: 10 }}>
                                                        [Frozen]
                                                    </span>
                                                </span>
                                            </div>
                                            :
                                            <div style={{fontWeight: 'bold' }}>
                                                <div>
                                                    {patient.provider ? patient.provider.organization_secondary_name ?
                                                        patient.provider.organization_secondary_name :
                                                        patient.provider.organization : ""}
                                                </div>
                                                {
                                                    patient.provider &&
                                                    patient.provider.location_secondary_name ?
                                                        patient.provider.location_secondary_name : ""
                                                }
                                            </div>
                                    }

                                </div>
                                {enrollerSummaryThirdColumn && apcmProgramSummaryBlock}
                                <br/>
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Provider: </span><span style={{ textAlign: "left" }}>{patient.provider ? patient.provider.provider : ""}</span>
                                        { changePorviderName && 
                                            <OverlayTrigger trigger={['hover', 'focus']} placement='top'
                                                    overlay={<Popover id="popover-trigger-hover-focus">
                                                        <span>{changePorviderName}</span>
                                                    </Popover>}>
                                            <span style={{ textAlign: "left", color:'rgb(234,111,96)', paddingLeft: 5 }}>(Change Pending)</span>
                                            </OverlayTrigger>
                                        }
                                    </div>
                                </div>
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Pronunciation: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.pronunciation ? patient.provider.pronunciation : "-"}</span></div>
                                </div>
                                
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Provider Gender: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.gender ? patient.provider.gender : "-"}</span></div>
                                </div>
                                <br/>
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Specialty: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.specialty_description ? patient.provider.specialty_description : "-"}</span></div>
                                </div>
                                
                                {/*
                        <div className="value-box" style={{width:'100%',textAlign:'center'}}>
                            <div>{patient.provider ? (patient.provider.address2) ? patient.provider.address1+' '+patient.provider.address2:patient.provider.address1: ""}</div>
                        </div>

                        <div className="value-box" style={{width:'100%',textAlign:'center'}}>
                            <div>{patient.provider ? patient.provider.city + "," + patient.provider.state + " " + patient.provider.zip_code: ""}</div>
                        </div>

                        */}
                               <br/>
                               <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Phone: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.phone ? numberToPhone(patient.provider.phone) : "-"}</span></div>
                                </div>
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>Fax: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.fax ? numberToPhone(patient.provider.fax) : "-"}</span></div>
                                </div>
                                <div className="value-box" style={{ width: '100%', textAlign: 'left' }}>
                                    <div><span style={{ fontWeight: 'bold' }}>After Hours: </span><span style={{ textAlign: "left" }}>{patient.provider && patient.provider.location_after_hours_phone ? numberToPhone(patient.provider.location_after_hours_phone) : "N/A"}</span></div>
                                </div>
                               
                            </div>
                            {showTimerSummaryColumn && !enrollerSummaryThirdColumn &&
                            <div className="patient-summary-item-box" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: 0 }}>
                                {showWorkTimer && !apcmPatient &&
                                <div className="value-box" style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <WorkLoggedCell
                                        data={patient}
                                        timerActive={this.state.patientDetailReady}
                                        timerNeeded={true}
                                    />
                                    <div style={{ color: '#000', fontSize: 14, fontWeight: 'normal', marginBottom: 4, fontStyle: 'italic' }}>
                                        Max Billable Time: {serviceGoalValue}
                                    </div>
                                </div>
                                }
                                {
                                (apcmCandidate || apcmPatient) && <div className="value-box" style={{ width: '100%', display: 'flex', flex: 1, borderTop: '1px solid #BDBDBD', flexDirection: 'column',
                                    paddingTop: apcmPatient ? 15 : 0 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 600 }}>APCM Program</div>
                                    {!isCne && <div style={{ display: 'flex', justifyContent: 'flex-start', padding: 10, paddingBottom: 0 }}>
                                        <span style={{ fontWeight: 600 }}>APCM Service Level:</span>
                                        <span style={{ paddingLeft: 15 }}>{patient.apcm_service_level ? patient.apcm_service_level : '-'}</span>
                                    </div>
                                    }
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        padding: 10,
                                        paddingBottom: 0,
                                        color: patient.apcm_level_change ? 'red' : 'inherit',
                                        fontWeight: patient.apcm_level_change ? 600 : 'normal',
                                    }}>
                                        <span style={{
                                            fontWeight: patient.apcm_level_change ? 600 : 400,
                                            fontStyle: 'italic',
                                        }}>APCM Eligible Level:</span>
                                        <span style={{
                                            paddingLeft: 15,
                                            fontStyle: 'italic',
                                            fontWeight: patient.apcm_level_change ? 600 : 'normal',
                                        }}>{patient.apcm_eligible_level ? patient.apcm_eligible_level : '-'}</span>
                                        <span style={{ paddingLeft: 10, marginTop: -2, fontStyle: 'italic', color: '#000000' }}>{direction}</span>
                                    </div>
                                </div>
                                }
                            </div>
                            }
                            <div className="patient-summary-item-box" style={{
                                ...summaryActionsPanelStyle,
                                borderRight: 'none',
                                position: showWorkTimer ? 'relative' : 'static',
                                justifyContent:'center',
                                alignItems:'center',
                                overflow: 'visible',
                            }}>
                                <div className="value-box" style={summaryActionsInnerStyle}>
                                    <div style={{ lineHeight: showWorkTimer ? 5 : 'normal' }}>
                                     {
                                       (!isCne && patient.apcm_level_change) && 
                                       ((clinicalUser && (patient.status == 1 || patient.status == 2)) || (isRetSpec && patient.status == 10) )
                                       && <Button id="patientCloseChart" onClick={this.openAPCMLevelChangeConsentModal.bind(this)} className="btn-primary patient-close-chart-btn" bsStyle="danger">Level Change Consent</Button>
                                     }     
                                     {
                                       !isCne && apcmCandidate && <Button id="patientCloseChart" onClick={this.openAPCMReconsentModal.bind(this)} className="btn-primary patient-close-chart-btn" bsStyle="danger">APCM Consent</Button>
                                     }   
                                     {patient.reconsent && <Button id="patientCloseChart" onClick={this.openReconsentModal.bind(this)} className="btn-primary patient-close-chart-btn" bsStyle="danger">Re-Consent Required</Button>}
                                        <Button id="patientCloseChart" onClick={this.closeChart.bind(this)} className="btn-primary patient-close-chart-btn" style={showWorkTimer ? undefined : { width: '100%' }}>Close Patient Chart</Button>
                                        {!isRpmEnrollerUser && (hidePatientSatisfaction ? '' : <Button onClick={this.togglePatientSatisfaction.bind(this)} disabled={!!patientSurveySubmitted} className="btn-success patient-close-chart-btn" style={showWorkTimer ? undefined : { width: '100%' }}>Patient Satisfaction</Button>)}

                                        {(this.props.activeUser && this.props.activeUser.center && (!isRPMUser && !isGAPSUser && !isRetSpec && !isRpmEnrollerUser) ) && Array.isArray(associatedCharts) && associatedCharts.length ? 
                                            <Button onClick={() => this.setState({ showAssociatedCharts: true })} className="btn-success patient-close-chart-btn" style={{background:"rgb(130,183,217)", border:'1px solid rgb(130,183,217)'}}>Associated Charts</Button> 
                                            : ''}
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        {(isButtonsAvailable || isSupportReasonAvailable) &&
                        <div style={{display:"flex"}} className="patient-summary-box">
                            <div style={{ flex: summaryNarrowFlex, padding:0 }} className="patient-summary-item-box">
                                <div style={{ padding:10,textAlign: 'center',clear:'both', padding: (isSupportReasonAvailable || isButtonsAvailable) && 10, 
                                    borderTop: (isSupportReasonAvailable || isButtonsAvailable) ? '1px solid #BDBDBD' : '' }}>
                                        {showSummaryEnrollButton &&
                                            <Button
                                                bsStyle={"success"}
                                                onClick={() => this.openEnrollModal(false)}
                                                style={{ marginRight: '10px' }}
                                            >
                                                {confirmButtonText}
                                            </Button>
                                        }

                                        {showSummaryDeclineButton &&
                                            <Button
                                                bsStyle="danger"
                                                onClick={() => this.setState({ showOptOut: true })}
                                            >
                                                {declineButtonText}
                                            </Button>
                                        }

                                        {isRetSpec && patient.status == 10 &&
                                            <Button
                                                disabled={patient.apcm_level_change}
                                                bsStyle="primary"
                                                onClick={() => this.setState({ showPatientStatusUpdate: true }, this.props.adminActions.getUnenrollReasons)}
                                                style={{ display: 'block', margin: '10px auto' }}
                                            >
                                                Change Patient Status
                                    </Button>
                                        }
                                    </div>
                            </div>
                            <div style={{ flex: summaryNarrowFlex, padding:0 }} className="patient-summary-item-box">
                               
                                     <div style={{ textAlign:"left", padding: (isButtonsAvailable || isSupportReasonAvailable) && 10, 
                                        borderTop: (isButtonsAvailable || isSupportReasonAvailable) ? '1px solid #BDBDBD' : '' }}>
                                       {
                                        isSupportReasonAvailable && <div><span style={{fontWeight:600}}>Support Reason:</span>
                                        <span style={{paddingLeft:15}}>{supportReason}</span>
                                        </div>
                                        
                                       } 
                                    </div>
                            </div>
                            <div style={{ flex: summaryWideFlex, minWidth: 0 }}>
                                <div style={{ textAlign:"left",padding: (isButtonsAvailable || isSupportReasonAvailable) && 10, borderTop: (isButtonsAvailable || isSupportReasonAvailable) ? '1px solid #BDBDBD' : '' }}>
                                {
                                        isSupportReasonAvailable && <div><span style={{fontWeight:600}}>Support Comment:</span>
                                            <span style={{paddingLeft:15}}>{patient.support_note ? patient.support_note : "-"}</span>
                                        </div>
                                       } 
                                </div>
                            </div>
                        </div>
                        }
                        {showRpmEligibleBanner &&
                            <div style={{
                                margin: '0 0 8px',
                                padding: '12px 16px',
                                border: '2px solid rgb(109,173,130)',
                                background: 'rgb(240,249,243)',
                                borderRadius: 4,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: showRpmEnrollerEnrollAction ? 'space-between' : 'flex-start',
                                gap: 12,
                            }}>
                                <div style={{ flex: 1, minWidth: 240 }}>
                                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                        + This patient is eligible for Remote Patient Monitoring.
                                    </div>
                                    <div style={{ fontSize: 14 }}>
                                        Recommended device class: {rpmDeviceTypeLabel || '—'}
                                        {rpmDiagnosisDisplay ? ` · Diagnosis: ${rpmDiagnosisDisplay}` : ''}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 16px', marginTop: 6, fontSize: 14 }}>
                                        <div><span style={{ fontWeight: 600 }}>Insurance 1:</span> {patient.insurance1 || 'N/A'}</div>
                                        <div><span style={{ fontWeight: 600 }}>Insurance 2:</span> {patient.insurance2 || 'N/A'}</div>
                                    </div>
                                </div>
                                {showRpmEnrollerEnrollAction &&
                                    <Button bsStyle="success" onClick={this.openRpmEnrollmentModal.bind(this)}>
                                        Enroll in RPM
                                    </Button>
                                }
                            </div>
                        }
                        {showDualRpmEligible &&
                            <div style={{
                                margin: '0 0 8px',
                                padding: '12px 16px',
                                border: '2px solid rgb(109,173,130)',
                                background: 'rgb(240,249,243)',
                                borderRadius: 4,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 12,
                            }}>
                                <div style={{ flex: 1, minWidth: 240 }}>
                                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                        + This patient is eligible for Remote Patient Monitoring.
                                    </div>
                                    <div style={{ fontSize: 14 }}>
                                        Recommended device class: {rpmDeviceTypeLabel || '—'}
                                        {rpmDiagnosisDisplay ? ` · Diagnosis: ${rpmDiagnosisDisplay}` : ''}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 16px', marginTop: 6, fontSize: 14 }}>
                                        <div><span style={{ fontWeight: 600 }}>Insurance 1:</span> {patient.insurance1 || 'N/A'}</div>
                                        <div><span style={{ fontWeight: 600 }}>Insurance 2:</span> {patient.insurance2 || 'N/A'}</div>
                                    </div>
                                </div>
                                <Button bsStyle="success" onClick={this.openDualEnrollmentModal.bind(this)}>
                                    {dualEnrollButtonText}
                                </Button>
                            </div>
                        }
                        {showAnyRpmEnrolled &&
                            <div style={{
                                margin: '0 0 8px',
                                padding: '12px 16px',
                                border: '2px solid rgb(109,173,130)',
                                background: 'rgb(240,249,243)',
                                borderRadius: 4,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 12,
                            }}>
                                <div style={{ flex: 1, minWidth: 240 }}>
                                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                        RPM Add-On — {rpmEnrollmentSummary ? rpmEnrollmentSummary.deviceDescription : (patient.rpm_device_description || rpmDeviceTypeLabel || '—')}
                                    </div>
                                    <div style={{ fontSize: 14, color: '#337ab7' }}>
                                        Participant ID {rpmEnrollmentSummary ? rpmEnrollmentSummary.participantId : (patient.rpm_validic_participant_id || '—')}
                                        {' · '}Enrolled {rpmEnrollmentSummary ? rpmEnrollmentSummary.enrolledTs : (patient.rpm_enrolled_ts ? moment(patient.rpm_enrolled_ts).format('MMM D, YYYY') : '—')}
                                    </div>
                                </div>
                            </div>
                        }
                        {showRpmThresholdChartAlerts &&
                            <RpmThresholdChartAlertsPanel
                                key={patient.id}
                                patientId={patient.id}
                                patient={patient}
                                chartContext={this.props.rpmThresholdChartContext}
                                todoLists={this.props.todoLists}
                                urgentTypes={this.props.urgentTypes}
                                rpmDeviceTypes={this.props.rpmDeviceTypes}
                                onComplete={this.handleCompleteRpmThresholdAlert}
                                completingTodoId={this.state.completingRpmAlertTodoId}
                            />
                        }
                        <div className="patient-diagnosis-box" style={{display:'flex', justifyContent:'space-between'}}>
                            <div>
                                <div style={{ float: 'left' }}>
                                    <span style={{ paddingRight: 10, fontWeight: 'bold' }}>Diagnosis Codes</span>
                                </div>
                                <div style={{ float: 'left', paddingLeft: 10 }}>
                                    <div>{patient.icd10code_1} - {patient.icd10code_1_desc}</div>
                                    <div style={{ paddingTop: 0 }}>{patient.icd10code_2} - {patient.icd10code_2_desc}</div>
                                    {(showAnyRpmEligible || showAnyRpmEnrolled) && rpmDiagnosisDisplay &&
                                        <div style={{ paddingTop: 4 }}>
                                            RPM: {rpmDiagnosisDisplay}
                                        </div>
                                    }
                                </div>
                            </div>
                            <a onClick={(e) => { 
                                e.preventDefault();
                                if(clinicalUser)
                                    this.props.adminActions.openChartSummary();
                                else this.setState({showNotes:true})
                            }}  style={{cursor:"pointer", padding:10}}>
                                View Chart Summary
                            </a> 
                        </div>
                    </div>

                    <div className="patient-top-bar" style={{display:'flex'}}>
                        {/* <div style={{width:'calc(100% - 155px)', overflow:'auto'}}> */}
                            <Nav style={{display:'flex',flex:1}} bsStyle="pills" activeKey={this.state.selectedOption} onSelect={this.onOptionSelect.bind(this)}
                                pullLeft>
                                <NavItem eventKey={'todoList'}>
                                    To Do List
                            </NavItem>
                                <NavItem eventKey={'generalNotes'}>
                                    Internal Notes
                            </NavItem>
                                {!isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavItem eventKey={'chartspan'}>
                                        Patient Profile
                                </NavItem>
                                }
                                {
                                    showRpmEnrolled
                                    && <NavItem eventKey={'rpmImpact'}>
                                    RPM/Impact
                                </NavItem>
                                }
                                
                                <NavItem eventKey={'caseHistory'}>
                                    History
                                </NavItem>
                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavDropdown title="Assessments" eventKey={'assessmentsOptions'} id="AssessmentDropdown">
                                        <MenuItem eventKey={"assessment"} id={"assessment"}>Care Management</MenuItem>
                                        <MenuItem eventKey={"MIPSAssessment"} id={"MIPSAssessment"}>Quality Measures</MenuItem>
                                        {
                                            patient.program_type == 'pathways_stroke_care'
                                            && <MenuItem eventKey={"PathwayStrokeCare"}>Pathways - Stroke Care</MenuItem>
                                        }

                                    </NavDropdown>
                                }
                                {isGAPSUser &&
                                <NavItem eventKey={'gaps'}>
                                    GAPS
                                </NavItem>
                                }
                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavItem eventKey={'carePlanAndGoals'}>
                                        Care Goal
                                </NavItem>
                                }
                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                <NavItem eventKey={'patientEducation'}>
                                    Patient Education
                                </NavItem>
                                }


                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavItem eventKey={'labs'}>
                                        Labs
                                </NavItem>
                                }
                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavDropdown title="New Records" eventKey={'newRecords'} id="NewRecordsDropdown">
                                        <NewRecordsDropdown />
                                    </NavDropdown>
                                }
                                {!isGAPSUser && !isCne && !isRPMUser &&
                                    <NavItem eventKey={'ccda'} disabled={(hasCheckedMedSummary === false || hasCheckedCCDA === false || hasCheckedHealthSummary === false || hasCheckedQualitySummary === false) || (hasCheckedCCDA && hasCheckedMedSummary && hasCheckedHealthSummary && hasCheckedQualitySummary && !ccdaAvailable && !medSummaryAvailable && !healthSummaryAvailable && !qualitySummaryAvailable)}>
                                        Health Records
                                </NavItem>
                                }
                                {!isGAPSUser && !isCne && !isRPMUser &&
                                    <NavItem eventKey={'phs'}>
                                        PHS/Confidential
                                </NavItem>
                                }
                                {
                                    messagesAvailable && !isGAPSUser && isUserAdmin && !isCne && !isRPMUser && !isRpmEnrollerUser ?
                                        <NavItem eventKey={'messagesDetail'} id="messagesPatientProfileTab">
                                            Cases
                                        {
                                                (this.props.patient && this.props.patient.unreadCases) ?
                                                    <span className="badge" style={{ fontSize:2,display: 'block', backgroundColor: '#FF0000', color: '#FFFFFF',
                                                    padding: 5,right: 4,top: 10, position:'absolute' }}>{" "}</span>
                                                    : ''
                                            }
                                        </NavItem>
                                        : ''
                                }
                                {
                                    !isGAPSUser && isUserAdmin && !isCne && !isRPMUser && !isRpmEnrollerUser ?
                                        <NavItem eventKey={'notificationDetails'} id="notificationPatientProfileTab">
                                            Notification
                                        {
                                                (this.props.patientNotificationCount > 0) ?
                                                    <span className="badge" style={{ display: 'inline', backgroundColor: '#FF0000', color: '#FFFFFF' }}>{this.props.patientNotificationCount}</span>
                                                    : ''
                                            }
                                        </NavItem>
                                        : ''
                                }
                                {!isGAPSUser && !isCne && !isRetSpec && !isRPMUser && !isRpmEnrollerUser &&
                                    <NavItem eventKey={'requestRecord'}>
                                        Request Record
                                </NavItem>
                                }
                                {
                                    <NavItem eventKey={'utilities'} id="patientUtility">
                                        Utilities
                                    </NavItem>
                                }

                            </Nav>
                        {/* </div> */}
                        
                    </div>
                </div>
                {
                    this.state.selectedOption == 'chartspan'
                        ?
                        <ChartspanWebComponent />
                        :
                        this.state.selectedOption == 'rpmImpact'
                            ?
                            <RPMImpactTab patient={patient} />
                            :
                        this.state.selectedOption == 'todoList'
                            ?
                            <TODOList showSecondaryTimer={this.showSecondaryTimer.bind(this)}
                                onOptionSelect={this.onOptionSelect.bind(this)} />
                            :
                            this.state.selectedOption == 'caseHistory'
                                ?
                                <CaseHistoryView />
                                :
                                this.state.selectedOption == 'assessment'
                                    ?
                                    <AssessmentView />
                                    :
                                    this.state.selectedOption == 'gaps'
                                    ?
                                        <GAPSPlanList showSecondaryTimer={this.showSecondaryTimer.bind(this)}
                                                  onOptionSelect={this.onOptionSelect.bind(this)} />
                                        :
                                    this.state.selectedOption == 'MIPSAssessment'
                                        ?
                                        <MIPSAssessmentView />
                                        :
                                        this.state.selectedOption == 'PathwayStrokeCare'
                                            ?
                                            <PathwayStrokeCareAssessmentView />
                                            :
                                            this.state.selectedOption == 'carePlanAndGoals'
                                                ?
                                                <CarePlanAndGoal showSecondaryTimer={this.showSecondaryTimer.bind(this)} />
                                                :
                                                this.state.selectedOption == 'patientEducation'
                                                    ?
                                                    <PatientEducation showSecondaryTimer={this.showSecondaryTimer.bind(this)} />
                                                    :
                                                this.state.selectedOption == 'generalNotes'
                                                    ?
                                                    <GeneralNotes />
                                                    :
                                                    this.state.selectedOption == 'labs'
                                                        ?
                                                        <Labs showSecondaryTimer={this.showSecondaryTimer.bind(this)} />
                                                        :
                                                        this.state.selectedOption == 'ccda'
                                                            ?
                                                            <CCDA />
                                                            :
                                                            this.state.selectedOption == 'phs'
                                                                ?
                                                                <PHS loadNoteNeeded={loadNoteNeeded} showSecondaryTimer={this.showSecondaryTimer.bind(this)}
                                                                onOptionSelect={this.onOptionSelect.bind(this)} isTriageUser={isTriageUser}/>
                                                                :
                                                                this.state.selectedOption == 'notificationDetails'
                                                                    ?
                                                                    <NotificationInboxItemDetail unreadCount={this.props.patientNotificationCount} selectedPatient={patient} />
                                                                    :
                                                                    this.state.selectedOption == 'messagesDetail'
                                                                    ?
                                                                    <ChartCaseMessagesList unreadCount={this.props.patientNotificationCount} selectedPatient={patient} showSecondaryTimer={this.showSecondaryTimer.bind(this)}/>
                                                                    :
                                                                    this.state.selectedOption == 'requestRecord'
                                                                        ?
                                                                        <RequestRecordContainer />
                                                                        :
                                                                        this.state.selectedOption == 'utilities'
                                                                            ?
                                                                            <Utilities showConfirmReset={this.state.showConfirmReset} showSecondaryTimer={this.showSecondaryTimer.bind(this)} lastPasswordReset={this.state.lastPasswordReset} isCne={isCne} />
                                                                            :
                                                                            <div />
                }
                <ReconsentRequiredModal onPopupHide={this.onReconsentPopupHide.bind(this)} 
                    show={this.state.showReconsentModal} 
                    showSecondaryTimer={this.showSecondaryTimer.bind(this)} />
                <APCMReconsentRequiredModal onPopupHide={this.onReconsentAPCMPopupHide.bind(this)} 
                    show={this.state.showAPCMReconsentModal} 
                    showSecondaryTimer={this.showSecondaryTimer.bind(this)}/>    
                <APCMLevelChangeConsentRequiredModal onPopupHide={this.onAPCMLevelChangeConsentAPCMPopupHide.bind(this)} 
                    show={this.state.showAPCMLevelChangeConsentModal} 
                    showSecondaryTimer={this.showSecondaryTimer.bind(this)}/>    
                <RpmDualEnrollmentModal
                    show={this.state.showDualEnrollmentModal}
                    onHide={this.onDualEnrollmentModalHide.bind(this)}
                    patient={patient}
                    rpmDeviceTypes={this.props.rpmDeviceTypes}
                    onDeclineCcm={this.onDualEnrollmentDeclineCcm.bind(this)}
                    onComplete={this.onDualEnrollmentComplete.bind(this)}
                />
                <RpmAddonEnrollmentModal
                    show={this.state.showRpmEnrollmentModal && !this.state.showRpmDeclineModal}
                    onHide={this.onRpmEnrollmentModalHide.bind(this)}
                    patient={patient}
                    rpmDeviceTypes={this.props.rpmDeviceTypes}
                    onEnrollComplete={this.onRpmEnrollmentComplete.bind(this)}
                    onOpenDecline={this.openRpmDeclineModal.bind(this)}
                />
                <RpmAddonDeclineModal
                    show={this.state.showRpmDeclineModal}
                    onHide={this.onRpmDeclineBack.bind(this)}
                    onBack={this.onRpmDeclineBack.bind(this)}
                    onDeclineSuccess={this.onRpmEnrollmentDecline.bind(this)}
                    patient={patient}
                />
                <RpmEnrollmentCompleteModal
                    show={this.state.showRpmEnrollmentCompleteModal}
                    onHide={this.onRpmEnrollmentCompleteModalHide.bind(this)}
                    workItemText={this.state.rpmEnrollmentSummary ? this.state.rpmEnrollmentSummary.workItemText : ''}
                />

                <CompleteTODOPopup
                    showSecondaryTimer={this.showSecondaryTimer.bind(this)}
                    onPopupHide={this.onRpmAlertCompletePopupHide}
                    patientId={patient.id}
                    show={this.state.showRpmAlertCompleteTodo}
                    selectedTodoData={this.state.rpmAlertCompleteTodoData}
                />
                <CloseChartPopup onPopupHide={this.onPopupHide.bind(this)} 
                    show={this.state.show} title={this.closeChartTitle}
                    onOptionSelect={this.onOptionSelect.bind(this)}
                    showSecondaryTimer={this.showSecondaryTimer.bind(this)} 
                    loadNoteNeeded={loadNoteNeeded}/>
                <InactivityCloseChartPopup onPopupHide={this.onAutoCloseChartHide.bind(this)} show={this.state.autoCloseChartShow} />
                <OptOutModal
                    patient={patient}
                    currentQueue={currentQueue}
                    isRPM={isRPMUser}
                    show={this.state.showOptOut}
                    onHide={() => this.setState({ showOptOut: false })}
                    declineText={declineButtonText}
                    onConfirm={this.handleOptOut}
                    optedOutReasons={this.props.optedOutReasons}
                />
                <PatientSatisfactionModal
                    show={this.state.showPatientSatisfactionModal}
                    onHide={this.togglePatientSatisfaction.bind(this)}
                    onConfirm={this.submitPatientSatisfaction.bind(this)}
                    updateComponent={this.updatePatientSatisfaction.bind(this)}
                    question={patientSurveyQuestion}
                    rating={this.state.satisfactionRating}
                    notes={this.state.satisfactionNotes}
                />
                { isRetSpec &&
                    <PatientStatusUpdateModal
                        patient={patient}
                        show={this.state.showPatientStatusUpdate}
                        onHide={() => this.setState({ showPatientStatusUpdate: false })}
                        onConfirm={this.handlePatientStatusChange.bind(this)}
                    // confirmText={ confirmButtonText }
                    // onConfirm={this.handleVerify}
                    />
                }
                <ConfirmationModal
                    isCne={isCne}
                    isRPM={isRPMUser}
                    isClinical={ !isGAPSUser  && !isCne && !isRPMUser}
                    patient={patient}
                    show={this.state.showConfirmation}
                    onScheduleDateSelected={this.onScheduleDateSelected.bind(this)}
                    onScheduleSlotSelected={this.onScheduleSlotSelected.bind(this)}
                    scheduleNextCallSlot={this.state.scheduleNextCallSlot}
                    scheduleNextCallDate={this.state.scheduleNextCallDate}
                    onHide={() => this.setState({ showConfirmation: false,scheduleNextCallDate:null })}
                    confirmText={confirmButtonText}
                    onConfirm={this.handleVerify}
                />
                <ScheduleNextCallPopup
                    show={this.state.showScheduleNextCall}
                    isCne={isCne}
                    isClinical={ !isGAPSUser  && !isCne && !isRPMUser}
                    onScheduleDateSelected={this.onScheduleDateSelected.bind(this)}
                    onScheduleSlotSelected={this.onScheduleSlotSelected.bind(this)}
                    scheduleNextCallSlot={this.state.scheduleNextCallSlot}
                    scheduleNextCallDate={this.state.scheduleNextCallDate}
                    onHide={() => this.setState({ showScheduleNextCall: false,scheduleNextCallDate:null })} />
                <EmailConfirmationModal
                    show={this.state.showEmailConfirmation}
                    onHide={() => this.setState({ showEmailConfirmation: false })}
                    onConfirm={this.handleEmailVerify}
                />
                <NotesModal
                    patient={patient}
                    organizationNote={organizationNote}
                    call_preference_description={call_preference_description}
                    engagementHistory={engagementHistory}
                    isRetSpec={isRetSpec}
                    show={this.state.showNotes}
                    onHide={() => this.setState({ showNotes: false })}
                    notes={this.state.notes}

                />
                <NotificationOfChartClosureRequestModal
                    patient={patient}
                    show={this.state.showNotificationOfChartClosureRequestModal}
                    onConfirm={this.handleConfirmChartClosureRequested}
                />
                { (this.props.activeUser && this.props.activeUser.center && (!isRPMUser && !isGAPSUser && !isRetSpec) ) && !!this.props.associatedCharts.length &&
                    <AssociatedChartsModal
                        patients={this.props.associatedCharts}
                        show={this.state.showAssociatedCharts}
                        onHide={() => this.setState({ showAssociatedCharts: false })}
                    />
                }
                <EditPatientInformationPopup
                    onPopupHide={this.onEditPatientInfoShowHide.bind(this)}
                    show={this.state.showEditPatientInfo} patientInfo={patient} />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    'ccdaAvailable': state.levelTwoDashboard.ccdaAvailable,
    'medSummaryAvailable': state.levelTwoDashboard.medSummaryAvailable,
    'healthSummaryAvailable': state.levelTwoDashboard.healthSummaryAvailable,
    'qualitySummaryAvailable': state.levelTwoDashboard.qualitySummaryAvailable,
    'phsAvailable': state.levelTwoDashboard.phsAvailable,
    'rpmSummaryAvailable': state.levelTwoDashboard.rpmSummaryAvailable,
    'confidentialNotesAvailable': state.levelTwoDashboard.confidentialNotesAvailable,
    'userId': state.auth.id,
    'userRole': state.auth.roles,
    'user': state.auth,
    'patientSSOToken': state.levelTwoDashboard.patientSSOToken,
    'app': state.app,
    'generalNotes': state.levelTwoDashboard.generalNotes,
    'patient': state.app.selectedPatient,
    'patientNotificationCount': state.notifications.patientNotificationCount,
    'form': state.form,
    'levelTwoDashboard': state.levelTwoDashboard,
    'activeUser': state.admin.activeUser,
    'patientSurveyQuestion': state.admin.patientSurveyQuestion,
    'patientSurveySubmitted': state.admin.patientSurveySubmitted,
    'chartClosureRequested': state.admin.chartClosureRequested,
    'selectedQueue': state.app.selectedQueue,
    'selectedPatient': state.app.selectedPatient,
    'organizationNote': state.levelTwoDashboard.organizationNote,
    'call_preference_description':state.levelTwoDashboard.call_preference_description,
    'engagementHistory': state.levelTwoDashboard.engagementHistory,
    'associatedCharts': state.levelTwoDashboard.associatedCharts,
    'configParams': state.admin.configParams,
    'optedOutReasons': state.levelTwoDashboard.optedOutReasons,
    'companies': state.admin.companies,
    'currentQueue': state.queue.currentQueue,
    'chartTabTobeOpen': state.levelTwoDashboard.chartTabTobeOpen,
    openRpmEnrollmentPatientId: state.levelTwoDashboard.openRpmEnrollmentPatientId,
    'patientServicesReasons': state.admin.patientServicesReasons,
    'selectedPatientChangeProvider': state.app.selectedPatientChangeProvider,
    'licensedUser': state.levelTwoDashboard.licensedUser,
    'urgentTypes': state.app.urgentTypes,
    'todoLists': state.levelTwoDashboard.todoLists,
    rpmDeviceTypes: state.queue.rpmDeviceTypes,
    rpmThresholdChartContext: state.queue.rpmThresholdChartContext,

});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
    appActions: bindActionCreators(appActionCreator, dispatch),
    commonActions: bindActionCreators(commonActionCreator, dispatch),
    notificationsAction: bindActionCreators(notificationsActionCreator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LevelTwoDashboard);
